var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoinbase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 8C16.5 12.4183 12.9183 16 8.5 16C4.08172 16 0.5 12.4183 0.5 8C0.5 3.58172 4.08172 0 8.5 0C12.9183 0 16.5 3.58172 16.5 8ZM13.1673 8.00065C13.1673 10.578 11.078 12.6673 8.50065 12.6673C5.92332 12.6673 3.83398 10.578 3.83398 8.00065C3.83398 5.42332 5.92332 3.33398 8.50065 3.33398C11.078 3.33398 13.1673 5.42332 13.1673 8.00065ZM7.66667 6.5C7.29847 6.5 7 6.79847 7 7.16667V8.83333C7 9.20153 7.29847 9.5 7.66667 9.5H9.33333C9.70153 9.5 10 9.20153 10 8.83333V7.16667C10 6.79847 9.70153 6.5 9.33333 6.5H7.66667Z",
    fill: "#2D65F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinbase);
export default __webpack_public_path__ + "static/media/coinbase.c39e5de01916421b71d56d6c4f368f8c.svg";
export { ForwardRef as ReactComponent };